// Kinematic Viscosity units with conversion factors to square meter per second (m²/s)
export const viscosityKinematicUnits = [
  { id: 'square-meter-per-second', name: 'Square Meter per Second', symbol: 'm²/s', plural: 'Square Meters per Second', factor: 1 },
  { id: 'square-centimeter-per-second', name: 'Square Centimeter per Second', symbol: 'cm²/s', plural: 'Square Centimeters per Second', factor: 0.0001 },
  { id: 'square-millimeter-per-second', name: 'Square Millimeter per Second', symbol: 'mm²/s', plural: 'Square Millimeters per Second', factor: 0.000001 },
  { id: 'square-foot-per-second', name: 'Square Foot per Second', symbol: 'ft²/s', plural: 'Square Feet per Second', factor: 0.09290304 },
  { id: 'square-inch-per-second', name: 'Square Inch per Second', symbol: 'in²/s', plural: 'Square Inches per Second', factor: 0.00064516 },
  { id: 'stokes', name: 'Stokes', symbol: 'St', plural: 'Stokes', factor: 0.0001 },
  { id: 'centistokes', name: 'Centistokes', symbol: 'cSt', plural: 'Centistokes', factor: 0.000001 },
  { id: 'square-foot-per-hour', name: 'Square Foot per Hour', symbol: 'ft²/h', plural: 'Square Feet per Hour', factor: 0.0000258064 },
];

export const popularViscosityKinematicConversions = [
  { from: 'square-meter-per-second', to: 'stokes' },
  { from: 'stokes', to: 'square-meter-per-second' },
  { from: 'stokes', to: 'centistokes' },
  { from: 'centistokes', to: 'stokes' },
  { from: 'square-meter-per-second', to: 'centistokes' },
  { from: 'centistokes', to: 'square-meter-per-second' },
  { from: 'square-centimeter-per-second', to: 'stokes' },
  { from: 'stokes', to: 'square-centimeter-per-second' },
  { from: 'square-millimeter-per-second', to: 'centistokes' },
  { from: 'centistokes', to: 'square-millimeter-per-second' },
  { from: 'square-foot-per-second', to: 'square-meter-per-second' },
  { from: 'square-meter-per-second', to: 'square-foot-per-second' },
  { from: 'square-foot-per-second', to: 'stokes' },
  { from: 'square-foot-per-hour', to: 'square-foot-per-second' },
  { from: 'square-inch-per-second', to: 'square-foot-per-second' },
];

export const getUnitById = (id) => viscosityKinematicUnits.find(unit => unit.id === id);

export const convertViscosityKinematic = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert kinematic viscosity units and learn the conversion formula.`;
};
